// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SpMxU","selected":"styles_selected__3Zk8n"};